export const capitalise = (input?: string) =>
  input?.split('.').map(([head, ...tail]) => `${head?.toUpperCase()}${tail.join('')}`).join(' ');

export const pluralise = (length = 0) => length === 1 ? '' : 's';
